import Check from '@/components/Check';
import Container from '@/components/Container';
import MarketingSection from './MarketingSection';

export default function MarketingProgramSimple({
  program,
}) {
  return (
    <MarketingSection className="bg-gradient-to-t from-gray-100 to-white" sectionTitle="Temario del entrenamiento">
      <Container maxWidth="max-w-screen-lg">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-y-16">
          {program.map(({ subject, content }, index) => (
            <div key={`program-${index}`} className="flex relative lg:col-span-6">
              <div className="absolute z-0 top-0 left-0 text-6xl font-extrabold text-gray-500 pointer-events-none leading-none opacity-10 -mt-4 -ml-6">
                {index + 1}
              </div>
              <div className="relative w-full z-10 space-y-4">
                <h3 className="text-xl font-medium">
                  {subject}
                </h3>
                <ul className="list-none space-y-2">
                  {content.map(({ title }, subjectIndex) => (
                    <li key={`program-${index}-subject-${subjectIndex}`} className="flex items-start space-x-3 text-gray-500 hover:text-gray-700 cursor-pointer">
                      <div className="mt-px pt-px">
                        <Check className="text-green-400" />
                      </div>
                      <div className="flex-1">
                        {title}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </MarketingSection>
  );
}
